// extracted by mini-css-extract-plugin
export default {"root":"styles_root__rjOkb","dialogTitle":"styles_dialogTitle__5OOoM","dialogCloseButton":"styles_dialogCloseButton__pWRPu","title":"styles_title__1whdu"};